/* eslint-disable @typescript-eslint/no-unused-vars */
import get from 'lodash/get';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'semantic-ui-react';

// eslint-disable-next-line import/no-cycle
import Blocks from '../../../components/Blocks';
import { bem } from '../../../core/design/bem';
import { loginModes } from '../../LoginScreen';
import { useForceUpdate, useLoginConfig } from '../../hooks';
import blockComponents from '../SideSection/blocks';
import './UserRegistrationModal.scss';

const css = bem('UserRegistrationModal');
const translationPrefix = 'login.registration.modal';

function UserRegistrationModal(props) {
  const { onCancel, onClose } = props;
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = useState(false);
  const config = useLoginConfig();
  const forceUpdate = useForceUpdate();
  const registrationBlocks = get(config, ['ctaSection', 'blocks'], []);
  const { registrationUrl, mode } = config;
  const LoginComponent = loginModes[mode] || loginModes.password;

  return (
    <>
      <Modal
        size="tiny"
        className={css().toString()}
        open
        onClose={() => {
          onClose();
          onCancel();
        }}
        closeIcon
      >
        <Modal.Header className={css('header').toString()}>
          {t(`${translationPrefix}.${!showLogin ? 'welcome' : 'sign-in'}`)}
        </Modal.Header>
        <Modal.Content className={css('content').toString()}>
          {showLogin ? (
            <LoginComponent
              mode={mode}
              onLogin={() => {
                forceUpdate();
                onClose();
                onCancel();
              }}
            />
          ) : (
            <>
              <Modal.Description className="please-sign-in">
                {t(`${translationPrefix}.please-sign-in`)}
              </Modal.Description>
              <Button
                primary
                basic
                className="sign-in"
                onClick={() => {
                  setShowLogin(true);
                }}
              >
                {t(`${translationPrefix}.sign-in`)}
              </Button>
              <Modal.Description className="no-account">
                {t(`${translationPrefix}.no-account`)}
                {registrationUrl ? (
                  <Link to={registrationUrl} className="sign-up" onClick={onCancel}>
                    {t(`${translationPrefix}.sign-up`)}
                  </Link>
                ) : (
                  <div style={{ marginTop: 10 }}>
                    <Blocks blocks={registrationBlocks} blockComponents={blockComponents} />
                  </div>
                )}
              </Modal.Description>
            </>
          )}
        </Modal.Content>
      </Modal>
    </>
  );
}

UserRegistrationModal.defaultProps = {
  onCancel: noop,
};
UserRegistrationModal.propTypes = {
  onCancel: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

export default UserRegistrationModal;
